import App from 'app/app.js';

function MasterSubjectService(MessageStore, $http, $q) {
  this.getSubjectDetails = function (lifetouchId, studentId, childLastName, childGrade, failSilently) {
    return $http
      .post('./masterSubject/getSubjectDetails', {
        lifetouchId: lifetouchId,
        studentId: studentId,
        childGrade: childGrade,
        studentLastName: childLastName
      })
      .then(
        function (response) {
          if (!!response.data && !!response.data.success === true && !!response.data.data) {
            return response.data.data;
          } else {
            if (!failSilently) {
              MessageStore.clear();
              if (!!response.data && !!response.data.error) {
                if (response.data.error.code === 'LMI_CLAIM_NOT_ALLOWED') {
                  MessageStore.createForm(response.data.error.code);
                } else if (response.data.error.code.startsWith('SECURITY_CHALLENGE_RETRY')) {
                  MessageStore.createSystem(response.data.error.code);
                } else {
                  MessageStore.createForm(response.data);
                }
              } else {
                MessageStore.createForm(response.data);
              }
            }
            return response.data;
          }
        }.bind(this),
        function (error) {
          MessageStore.createSystem('COMMON_TEXT_ERROR');
          return { systemError: error };
        }
      );
  };

  this.verifyMasterSubject = function (ltMasterSubjectUuid) {
    var url = './masterSubject/verifyMasterSubject/' + ltMasterSubjectUuid;
    return $http
      .post(url)
      .then(
        function (response) {
          if (!response.data.success) {
            MessageStore.createSystem(response.data.Message);
          }
        }.bind(this)
      )
      .catch(function (error) {
        MessageStore.createSystem(error.data.error.code);
      });
  };

  this.getSubjectDetailsByUser = function () {
    return $http.get('./masterSubject/getSubjectDetailsByUser').then(
      function (response) {
        if (!!response.data && !!response.data.success === true && !!response.data.data) {
          return response.data.data;
        } else {
          return response.data;
        }
      }.bind(this),
      function (error) {
        MessageStore.createSystem('COMMON_TEXT_ERROR');
        return { systemError: error };
      }
    );
  };

  this.getMasterSubjectById = function (ltMasterSubjectUuid) {
    return $http.get('./masterSubject/' + ltMasterSubjectUuid + '/subjectDetails').then(
      ({ data }) => {
        if (data?.success && data?.data) {
          return data.data;
        } else {
          return data;
        }
      },
      (systemError) => {
        MessageStore.createSystem('COMMON_TEXT_ERROR');
        return { systemError };
      }
    );
  };

  this.verifySubjectIDontHaveCode = function (
    captureSessionKey,
    portraitId,
    accessCode,
    lastName,
    grade,
    byCaptureSessionKey
  ) {
    var params = '?lastName=' + lastName + '&grade=' + grade;
    if (byCaptureSessionKey) {
      params += '&captureSessionKey=' + captureSessionKey;
    } else {
      params += '&portraitId=' + portraitId + '&accessCode=' + accessCode;
    }
    return $http.get('masterSubject/verifyMasterSubject/iDontHaveCode' + params).then(
      function (response) {
        if (!!response.data && !!response.data.success === true && !!response.data.data) {
          return response.data.data;
        } else {
          return response.data;
        }
      }.bind(this),
      function (error) {
        if (!!data && !!data.error && data.error.code === 'LMI_CLAIM_NOT_ALLOWED') {
          MessageStore.createSystem(data.error.code);
        } else {
          MessageStore.createSystem('COMMON_TEXT_ERROR');
        }
        return { systemError: error };
      }
    );
  };

  this.removeSubjectFromUser = function (ltMasterSubjectUuid) {
    if (!ltMasterSubjectUuid) {
      return $q.resolve();
    }
    return $http
      .delete('./masterSubject/removeSubjectFromUser/' + ltMasterSubjectUuid)
      .then(function (response) {
        if (!!response.data && !!response.data.success === true && !!response.data.data) {
          return response.data.data;
        } else {
          return response.data;
        }
      })
      .catch(function (error) {
        return { systemError: error };
      });
  };
}

App.service('MasterSubjectService', ['MessageStore', '$http', '$q', MasterSubjectService]);
